import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData } from '../../../services/admin/abstractReceipt/programManagerServices';
import { Modal, Button, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';


const ApprovedProgramManager = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ id: '',
    conference_committee : '',
    conf_shortname : '',
    sub_domain : '',
    series: '',
    expertise : '',
    coordinator_name : '',
    designation : '',
    config_email : '',
    });
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [seriesFilter, setSeriesFilter] = useState('');
  const [subDomainFilter, setSubDomainFilter] = useState('');
  
  // Fetch data
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ status: 1 });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData]);

  
  const openModal = (data = { id: '',conference_committee : '',
    conf_shortname : '',
    sub_domain : '',
    series: '',
    expertise : '',
    coordinator_name : '',
    designation : '',
    config_email : '',
    }) => {
    setForm(data);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
      const filteredData = useMemo(() => {
      
          return dataList
            .filter((data) => {
              const matchesText =
                data.sub_domain.toLowerCase().includes(searchText.toLowerCase());
            
              // Other filters (series, subDomain, country)
              const matchSeries = !seriesFilter || data.series === seriesFilter;
              const matchSubDomain = !subDomainFilter || data.sub_domain === subDomainFilter;
      
              return matchesText && matchSubDomain && matchSeries;
            })
            .sort((a, b) => {
              // If both startDate and endDate are selected, sort the data by date
                return new Date(b.updatedAt) - new Date(a.updatedAt); // Sort descending
            });
      }, [dataList, searchText, subDomainFilter, seriesFilter,]);
         
  

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '10%',
    },
    {
        name: 'Sub Domain',
        selector: (row) => row.sub_domain || 'N/A',
        sortable: true,
        width: '15%',
        wrap: true
    },
    {
      name: 'Conference Committee',
      selector: (row) => row.conference_committee,
      sortable: true,
      width: '20%',
      wrap: true
    },
    {
    name: 'Series',
    selector: (row) => {
      // Assuming the `series` field is in format like "2025-11" or "2025-11-15"
      const date = new Date(row.series);
      
      // Format as "2025-11 Nov 2025"
      const year = date.getFullYear();
      const month = date.getMonth(); // 0-based index, so we add 1
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      
      return ` ${months[month]} ${year}`;
    },
    sortable: true,
    width: '10%',
    wrap: true
    },
    {
      name: 'Short Name',
      selector: (row) => row.conf_shortname || 'N/A',
      sortable: true,
      width: '20%',
      wrap: true
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button variant="primary" size="sm" onClick={() => openModal(row)} className="me-2"> <i className="align-middle far fa-fw fa-eye"></i> </Button>
        </div>
      ),
      width: '20%',
      wrap: true
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
         <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Series</span>
              <select className="form-control" value={seriesFilter} onChange={(e) => setSeriesFilter(e.target.value)}>
                <option value="">All Series</option>
                {Array.from(new Set(dataList.map(item => item.series))).sort((a,b)=>b.localeCompare(a)).map((series, idx) => (
                  <option key={idx} value={series}>{series}</option>
                ))}
              </select>
            </div>
            {/* Dropdown for Filters */}
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Sub Domain</span>
              <select className="form-control" value={subDomainFilter} onChange={(e) => setSubDomainFilter(e.target.value)}>
                <option value="">All Subdomains</option>
                {Array.from(new Set(dataList.map(item => item.sub_domain))).sort((a,b)=>a.localeCompare(b)).map((subDomain, idx) => (
                  <option key={idx} value={subDomain}>{subDomain}</option>
                ))}
              </select>
            </div>
            
          </div> 
        </div>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4 text-dark">PDF Generation / Abstract Receipt / Conference Manager / Approved Conference Manager</p>
            </div>

          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText} onChange={handleSearchChange} />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" backdrop="static" show={showModal} onHide={() => setShowModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>View</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Table striped bordered hover responsive className="table-sm">
                <thead>
                     
                    </thead>
                    <tbody>
                    </tbody>
                    <br></br>
                    <thead>
                      <tr>
                        <th className='bg-secondary text-white' colSpan={2}>Conference Manager Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Conference Committee</td>
                        <td>{form.conference_committee	}</td>
                      </tr>
                      <tr>
                        <td>Conf shortname</td>
                        <td>{form.conf_shortname}</td>
                      </tr>
                      <tr>
                        <td>Expertise</td>
                        <td>{form.expertise}</td>
                      </tr>
                      <tr>
                        <td>Coordinator Name</td>
                        <td>{form.coordinator_name}</td>
                      </tr>
                      <tr>
                        <td>Designation</td>
                        <td>{form.designation}</td>
                      </tr>
                      <tr>
                        <td>Config email</td>
                        <td>{form.config_email}</td>
                      </tr>
                      <tr>
                        <td>Sub Domain</td>
                        <td>{form.sub_domain}</td>
                      </tr>
                      <tr>
                      <td>Signature</td>
                      <td>
                          <img
                            src={form.reviewer_signature}
                            width="300" 
                            alt="Reviewer Signature"
                          />
                      </td>
                      </tr>   
                    </tbody>
                    <br></br>
                  </Table>
             
            </Modal.Body>
          </Modal>
        </div>
        <Footer />
        </div>
        )};
      </div>
    </div>
  );
};

export default ApprovedProgramManager;
